import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NaTinymceOptions } from './na-tinymce.options';
import { NaTinymceComponent } from './na-tinymce.component';
import { ScriptService } from './tinymce.script.service';

@NgModule({
  imports: [CommonModule],
  declarations: [NaTinymceComponent],
  exports: [NaTinymceComponent],
})
export class NaTinymceModule {
  static forRoot(options: NaTinymceOptions): ModuleWithProviders {
    return {
      ngModule: NaTinymceModule,
      providers: [
        ScriptService,
        { provide: NaTinymceOptions, useValue: options },
      ],
    };
  }
}
